import { bindCallbackToElement } from '../../../util';

export const events = ({ tracker, condition }) => {
  const gtag = tracker;
  const { userId } = condition;

  return {
    CLICK(data) {
      const { eventName, payload } = data;
      gtag('event', eventName, { ...payload, user_id: userId });
    },
    BIND_CLICK(data) {
      const { eventName, payload, element } = data;
      const callback = (e) => gtag('event', eventName, { ...payload, user_id: userId });
      bindCallbackToElement({ element, event: 'click', callback });
    },
    PLAY(data) {
      const { eventName, payload } = data;
      gtag('event', eventName, { ...payload, user_id: userId });
    },
    BIND_PLAY(data) {
      const { eventName, payload, element } = data;
      const callback = (e) => gtag('event', eventName, { ...payload, user_id: userId });
      bindCallbackToElement({ element, event: 'play', callback });
    },
  };
};
